import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { filter, pairwise } from 'rxjs/operators';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

// import { TranslateService } from '@ngx-translate/core';

// [anand] [ml5174: use attid in comments] need to check where we can move router patch Component
import { HttpClientService, UtilityService, RouterPatchComponent, AuthenticationService } from 'lib/ng2-sapmp/src/providers';
import { ENV, PageTitle } from 'config';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal/confirm-modal-popup.model';
import { HeaderService } from './pages/header/header.service';
// import { version } from '../../package.json';
import packageJson from '../../package.json';

// TODO [ml5174] ENV_Var should be typed
declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var ENV_PORTAL: any;
declare var isTCinitialized: any;
declare var Inq: any;
const abcUrl = '/businessconsole/home';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  // public version: string = version;
  public version: string = packageJson.version;
  appPortal: string = ENV_PORTAL;
  portalVariable: any = {
    envVariable: '',
    baseUrl: '',
    redirectUrl: ''
  };
  showModal: boolean = false;


  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService,
    private router: Router,
    private route: ActivatedRoute,
    // private translate: TranslateService,
    private headerService: HeaderService,
    private authenticationService: AuthenticationService) {
    utilityService.setEnvConfig(ENV[ENV_VAR]); // setting app config in service
    utilityService.setPageTitleConfig(PageTitle); // setting app config in service

    // translate.addLangs(['en', 'es']);
    // translate.setDefaultLang('en');
    // let browserLang = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|es/) ? browserLang : 'en');

    RouterPatchComponent.navigateByUrl.subscribe((url: string) => {
      this.router.navigateByUrl(url);
    });

    this.authenticationService.getLoginModalStatus().subscribe(status => {
      this.showModal = status;
    })
  }
  public getUrlForLiElement(liElement) {
    if (liElement && liElement.children[0]) {
      let url = liElement.children[0].href;
      return url;
    }
  }


  initializeChat() {
    try {
      console.log('initializedChat' + isTCinitialized);
      if (isTCinitialized) {
        isTCinitialized = false;
        Inq.reinitChat();
      }
    } catch (e) {
      console.warn('inqFrame', 'failed!');
    }
  }

  ngOnInit(): void {

    // document.title = this.utilityService.getPageTitleConfig()['/home'];
    if(this.router.url === '/care/home'){
      document.title = this.utilityService.getPageTitleConfig()['/care/home'];
    }else if(this.router.url === '/home'){
      document.title = this.utilityService.getPageTitleConfig()['/home'];
    }

    // below code sets the page scroll at top position
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
      , pairwise())
      .subscribe((e: [NavigationEnd, NavigationEnd]) => {
        const navArray = e;
        if (navArray && navArray.length > 0) {
          sessionStorage.setItem('previousRoute', navArray[0].url);
          sessionStorage.setItem('currentRoute', navArray[1].url);
        }
        if (!(e instanceof NavigationEnd)) {
          return;
        }
      });
    this.portalVariable.envVariable = this.appPortal;
    this.portalVariable.baseUrl = abcUrl;
  }

  ngAfterViewInit(): void {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd))
      .subscribe((evt) => {
        this.initializeChat();
        window.scrollTo(0, 0);
        const element: HTMLElement = document.getElementById('focusLogo');
        const logoutElementTitle: HTMLElement = document.getElementById('logoutContainerTitle');
        if (logoutElementTitle) {
          document.getElementById('logoutContainerTitle').focus();
        }
        else {
          document.getElementById('focusLogo').innerHTML = document.title;
          document.getElementById('focusLogo').focus();
        }
        setTimeout(() => {
          this.headerService.initUser()
        }, 1000);

      });
  }

  callTokenRefresh() {
    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      // refreshes token for logged in scenario upon page load
      this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
    }
  }

  handleError = (error) => { // Arrow function is necessary as the context should be Parent class
    return throwError('Server Error');
  }

}
